export interface IEquipmentHistory {
  initialCountTime: number;
  modifiedBy: string[];
  mobilizationInitialCountTime: number;
  mobilizationModifiedBy: string[];
}
